<template>
    <div>
        <div class="ck-dayin">
        <div class="titles">
            <span>广州亿星人居环境设备有限公司</span>
            <span>产品送(提)货单</span>
        </div>
        <div class="center">
            <span>合同订单号  {{tableData.contract_number}}</span>
            <span class="right">收货人电话 {{tableData.phone}} </span>
            <span class="right" style="display: inline-block;width: 25%"> 发货日期 {{tableData.send_time|formatter}}</span>
        </div>
        <div class="center">
            <span style="display: inline-block">发货单号 {{tableData.order_number}}　</span>
            <span style="display: inline-block;text-align: center">　发货通知单号 {{tableData.order_number}}　</span>
            <span style="display: inline-block;text-align: center">　收货人 {{tableData.FShr}}</span>
            <span style="float:right;text-align: right">交货方式 　{{tableData.transport_way}}</span>
        </div>
        <div style="display: block">
            <span style="float: left">收货地址 {{tableData.address}}</span>
            <span class="right">业务员　</span>
        </div>
        <div class="table">
            <table style="width: 100%;">
                <tr>
                    <td>序号</td>
                    <td colspan="2">产品名称</td>
                    <td colspan="4">规格型号</td>
                    <td colspan="2">单位</td>
                    <td colspan="2">实发数量</td>
                </tr>
                <tr v-for="(item, index) in goodsList">
                    <td>{{index+1}}</td>
                    <td colspan="2">{{item.goods_name}}</td>
                    <td colspan="4" class="fs18">{{item.model}}</td>
                    <td colspan="2">{{item.unit}}</td>
                    <td colspan="2">{{item.goods_num}}</td>
                </tr>
                <tr v-for="(item, index) in ShengLength">
                    <td><span style="opacity: 0">-</span></td>
                    <td colspan="2"><span style="opacity: 0">-</span></td>
                    <td colspan="4" class="fs18"><span style="opacity: 0">-</span></td>
                    <td colspan="2"><span style="opacity: 0">-</span></td>
                    <td colspan="2"><span style="opacity: 0">-</span></td>
                </tr>
                <tr>
                    <td colspan="9">合计</td>
                    <td colspan="2">{{allNum1}}</td>
                </tr>
            </table>
            <div class="btn">
                <span style="display: inline-block;width: 40%">制单　{{tableData.made_person}}</span>
                <span style="display: inline-block;width:38%">收货单位签收盖章</span>
                <span style="display: inline-block;width:20%">发货单位签收盖章 </span>
            </div>
            <div>服务热线电话: 020-86187083　020-26092862</div>
            <div>售后服务电话: 020-36180565</div>
            <div>广州市白云区城西路888号绿地中心2602</div>
        </div>
    </div>
        <div class="ck-dayin" v-show="isShow">
            <div class="titles">
                <span>广州亿星人居环境设备有限公司</span>
                <span>产品送(提)货单</span>
            </div>
            <div class="center">
                <span>合同订单号  {{tableData.contract_number}}</span>
                <span class="right">收货人电话 {{tableData.phone}} </span>
                <span class="right" style="display: inline-block;width: 25%"> 发货日期 {{tableData.send_time|formatter}}</span>
            </div>
            <div class="center">
                <span style="display: inline-block">发货单号 {{tableData.order_number}}　</span>
                <span style="display: inline-block;text-align: center">　发货通知单号 {{tableData.order_number}}　</span>
                <span style="display: inline-block;text-align: center">　收货人 {{tableData.FShr}}</span>
                <span style="float:right;text-align: right">交货方式 　{{tableData.transport_way}}</span>
            </div>
            <div style="display: block">
                <span style="float: left">收货地址 {{tableData.address}}</span>
                <span class="right">业务员　</span>
            </div>
            <div class="table">
                <table style="width: 100%;">
                    <tr>
                        <td>序号</td>
                        <td colspan="2">产品名称</td>
                        <td colspan="4">规格型号</td>
                        <td colspan="2">单位</td>
                        <td colspan="2">实发数量</td>
                    </tr>
                    <tr v-for="(item, index) in goodsList1">
                        <td>{{index+1}}</td>
                        <td colspan="2">{{item.goods_name}}</td>
                        <td colspan="4" class="fs18">{{item.model}}</td>
                        <td colspan="2">{{item.unit}}</td>
                        <td colspan="2">{{item.goods_num}}</td>
                    </tr>
                    <tr v-for="(item, index) in ShengLength">
                        <td><span style="opacity: 0">-</span></td>
                        <td colspan="2"><span style="opacity: 0">-</span></td>
                        <td colspan="4" class="fs18"><span style="opacity: 0">-</span></td>
                        <td colspan="2"><span style="opacity: 0">-</span></td>
                        <td colspan="2"><span style="opacity: 0">-</span></td>
                    </tr>
                    <tr>
                        <td colspan="9">合计</td>
                        <td colspan="2">{{allNum1}}</td>
                    </tr>
                </table>
                <div class="btn">
                    <span style="display: inline-block;width: 40%">制单　{{tableData.made_person}}</span>
                    <span style="display: inline-block;width:38%">收货单位签收盖章</span>
                    <span style="display: inline-block;width:20%">发货单位签收盖章 </span>
                </div>
                <div>服务热线电话: 020-86187083　020-26092862</div>
                <div>售后服务电话: 020-36180565</div>
                <div>广州市白云区城西路888号绿地中心2602</div>
            </div>
        </div>
        <div class="ck-dayin" v-show="isShow2">
            <div class="titles">
                <span>广州亿星人居环境设备有限公司</span>
                <span>产品送(提)货单</span>
            </div>
            <div class="center">
                <span>合同订单号  {{tableData.contract_number}}</span>
                <span class="right">收货人电话 {{tableData.phone}} </span>
                <span class="right" style="display: inline-block;width: 25%"> 发货日期 {{tableData.send_time|formatter}}</span>
            </div>
            <div class="center">
                <span style="display: inline-block">发货单号 {{tableData.order_number}}　</span>
                <span style="display: inline-block;text-align: center">　发货通知单号 {{tableData.order_number}}　</span>
                <span style="display: inline-block;text-align: center">　收货人 {{tableData.FShr}}</span>
                <span style="float:right;text-align: right">交货方式 　{{tableData.transport_way}}</span>
            </div>
            <div style="display: block">
                <span style="float: left">收货地址 {{tableData.address}}</span>
                <span class="right">业务员　</span>
            </div>
            <div class="table">
                <table style="width: 100%;">
                    <tr>
                        <td>序号</td>
                        <td colspan="2">产品名称</td>
                        <td colspan="4">规格型号</td>
                        <td colspan="2">单位</td>
                        <td colspan="2">实发数量</td>
                    </tr>
                    <tr v-for="(item, index) in goodsList2">
                        <td>{{index+1}}</td>
                        <td colspan="2">{{item.goods_name}}</td>
                        <td colspan="4" class="fs18">{{item.model}}</td>
                        <td colspan="2">{{item.unit}}</td>
                        <td colspan="2">{{item.goods_num}}</td>
                    </tr>
                    <tr v-for="(item, index) in ShengLength">
                        <td><span style="opacity: 0">-</span></td>
                        <td colspan="2"><span style="opacity: 0">-</span></td>
                        <td colspan="4" class="fs18"><span style="opacity: 0">-</span></td>
                        <td colspan="2"><span style="opacity: 0">-</span></td>
                        <td colspan="2"><span style="opacity: 0">-</span></td>
                    </tr>
                    <tr>
                        <td colspan="9">合计</td>
                        <td colspan="2">{{allNum1}}</td>
                    </tr>
                </table>
                <div class="btn">
                    <span style="display: inline-block;width: 40%">制单　{{tableData.made_person}}</span>
                    <span style="display: inline-block;width:38%">收货单位签收盖章</span>
                    <span style="display: inline-block;width:20%">发货单位签收盖章 </span>
                </div>
                <div>服务热线电话: 020-86187083　020-26092862</div>
                <div>售后服务电话: 020-36180565</div>
                <div>广州市白云区城西路888号绿地中心2602</div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                tableData: JSON.parse(localStorage.getItem('CangkuDayin2')),
                ShengLength: '',
                allNum1: 0,
                allNum2: 0,
                allNum3: 0,
                isShow: false,
                isShow2: false,
                goodsList: [],
                goodsList1: [],
                goodsList2: [],
            }
        },
        filters: {
            formatter(time) {
                if (time === '' || time === '0') {
                    return ''
                }
                return new Date(time * 1000).toLocaleDateString().toString().replace(/\//g, '-')
            }
        },
        created() {
            console.log(this.tableData.send_time);
            if (this.tableData.goods.length < 12) {
                this.ShengLength = 12 - this.tableData.goods.length
                this.tableData.allNum = 0
                this.goodsList = this.tableData.goods
                this.tableData.goods.forEach(item => {
                    this.allNum1 += +item.goods_num
                })
            } else if (this.tableData.goods.length >= 12 && this.tableData.goods.length < 24) {
                this.isShow = true
                for (var i = 0; i <= 11; i++) {
                    console.log(this.tableData.goods[i].unit);
                    this.goodsList.push({unit: this.tableData.goods[i].unit, goods_num: this.tableData.goods[i].goods_num, goods_name: this.tableData.goods[i].goods_name, model: this.tableData.goods[i].model})
                }
                this.goodsList.forEach(item => {
                    this.allNum1 += Number(item.goods_num)
                })
                for (var j = 12; j < this.tableData.goods.length; j++) {
                    this.goodsList1.push({unit: this.tableData.goods[j].unit, goods_num: this.tableData.goods[j].goods_num, goods_name: this.tableData.goods[j].goods_name, model: this.tableData.goods[j].model})
                }
                console.log(this.goodsList1);
                this.goodsList1.forEach(item => {
                    this.allNum2 += +item.goods_num
                })
            } else if (this.tableData.goods.length >= 24 && this.tableData.goods.length < 36) {
                this.isShow = true
                this.isShow2 = true
                for (var i = 0; i <= 11; i++) {
                    console.log(this.tableData.goods[i].unit);
                    this.goodsList.push({unit: this.tableData.goods[i].unit, goods_num: this.tableData.goods[i].goods_num, goods_name: this.tableData.goods[i].goods_name, model: this.tableData.goods[i].model})
                }
                this.goodsList.forEach(item => {
                    this.allNum1 += Number(item.goods_num)
                })
                for (var j = 12; j < 23; j++) {
                    this.goodsList1.push({unit: this.tableData.goods[j].unit, goods_num: this.tableData.goods[j].goods_num, goods_name: this.tableData.goods[j].goods_name, model: this.tableData.goods[j].model})
                }
                this.goodsList1.forEach(item => {
                    this.allNum2 += +item.goods_num
                })
                for (var k = 23; k < this.tableData.goods.length; k++) {
                    this.goodsList2.push({unit: this.tableData.goods[k].unit, goods_num: this.tableData.goods[k].goods_num, goods_name: this.tableData.goods[k].goods_name, model: this.tableData.goods[k].model})
                }
                this.goodsList2.forEach(item => {
                    this.allNum3 += +item.goods_num
                })
            }
        },
        mounted() {
            window.print()
        }
    }
</script>
<style lang="less" scoped>
    .right{
        float: right;
    }
    .ck-dayin{
        font-size: 11px;
        width: 98%;
        .titles{
            text-align: center;
            font-size: 18px;
            span{
                display: block;
            }
        }
        .center{
            display: block;
            width: 100%;
        }
        .fs25{
            font-size: 25px;
            font-weight: bold;
        }
        .fs18{
            /*font-size: 16px;*/
            /*font-weight: bold;*/
        }
        .table{
            display: inline-block;
            width: 100%;
            table,table tr th, table tr td { border:1px solid #000000; }
            table{
                text-align: center; border-collapse: collapse;line-height: 20px;
                input{
                    border: 0px;
                }

            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/router/CangkuDayin2.vue